import MUITab from "@mui/material/Tab";

const Tab = MUITab;

export default Tab;
